import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../../../entities/filters/base-url-params-filter';
import { SimplePicker } from '../formik-fields/simple-picker';
import { FilterItem } from '@sr/dto';

export const SimpleParamFilter = <ItemIdType extends string | number = number>({ queryParamName, label, size = 'medium', items, defaultValue = undefined }: BaseUrlParamsFilterProps & { items: FilterItem<ItemIdType>[], defaultValue?: ItemIdType }) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName} defaultValue={defaultValue}>
      <Field fullWidth name={queryParamName} label={label} clearable={true} size={size} component={SimplePicker<ItemIdType>} items={items} />
    </BaseUrlParamsFilter>
  );
};
